import { inject, injectable } from 'inversify';
import type { Props as JoyRideProps, Step } from 'react-joyride';
import { TYPES } from '../ioc/types';
import type { LearningGuideStore } from '../stores/LearningGuide.store';
import { LearningGuideMenuItemService } from '../services/LearningGuideMenuItem.service';
import { STARTING_GUIDE_TYPES } from '@/engine/app/modules/learningGuide';
import type { LearningGuideService } from '@/engine/app/modules/learningGuide';

@injectable()
export class LearningGuideController {
  private _learningGuideStore: LearningGuideStore;

  private _menuItemStateService: LearningGuideMenuItemService;

  private _engineLearningGuideService: LearningGuideService;

  public constructor(
    @inject(TYPES.LearningGuideStore) learningGuideStore: LearningGuideStore,
    @inject(STARTING_GUIDE_TYPES.LearningGuideMenuItemService) learningGuideMenuItemState: LearningGuideMenuItemService,
    @inject(STARTING_GUIDE_TYPES.LearningGuideService) engineLearningGuideService: LearningGuideService
  ) {
    this._learningGuideStore = learningGuideStore;
    this._menuItemStateService = learningGuideMenuItemState;
    this._engineLearningGuideService = engineLearningGuideService;
  }

  public get joyRideProps(): Omit<JoyRideProps, 'steps'> {
    return this._learningGuideStore.joyRideProps;
  }

  public get steps(): Array<Step> {
    return this._learningGuideStore.steps;
  }

  public stopGuide(): void {
    this._engineLearningGuideService.stopLearningGuide();

    this._menuItemStateService.blinkMenuItem();
  }
}
